import React from 'react';
import { styled } from '@compiled/react';
import { defineMessages, useIntl } from 'react-intl';

import { token } from '@atlaskit/tokens';
import Button from '@atlaskit/button/button';
import UnstarredIcon from '@atlaskit/icon/core/star-unstarred';

const i18n = defineMessages({
	starLabel: {
		id: 'favourite-button.placeholder.star.label',
		defaultMessage: 'Star',
		description:
			'Accessible label for the favourite/star button placeholder shown while the button is loading',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledButton = styled(Button)({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		minWidth: '30px',
		paddingLeft: token('space.025'),
		paddingRight: token('space.025'),
	},
});

export const FavouriteButtonPlaceholder = (): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<StyledButton
			data-test-id="page-favourite-button-placeholder"
			appearance="subtle"
			iconBefore={
				<UnstarredIcon
					label={formatMessage(i18n.starLabel)}
					color="currentColor"
					spacing="spacious"
				/>
			}
			isDisabled
		/>
	);
};
